/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GDPRConsentLevel } from './GDPRConsentLevel';
import {
    GDPRConsentLevelFromJSON,
    GDPRConsentLevelFromJSONTyped,
    GDPRConsentLevelToJSON,
    GDPRConsentLevelToJSONTyped,
} from './GDPRConsentLevel';

/**
 * 
 * @export
 * @interface GDPRConsentRequest
 */
export interface GDPRConsentRequest {
    /**
     * 
     * @type {Array<GDPRConsentLevel>}
     * @memberof GDPRConsentRequest
     */
    consent_levels: Array<GDPRConsentLevel>;
}

/**
 * Check if a given object implements the GDPRConsentRequest interface.
 */
export function instanceOfGDPRConsentRequest(value: object): value is GDPRConsentRequest {
    if (!('consent_levels' in value) || value['consent_levels'] === undefined) return false;
    return true;
}

export function GDPRConsentRequestFromJSON(json: any): GDPRConsentRequest {
    return GDPRConsentRequestFromJSONTyped(json, false);
}

export function GDPRConsentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GDPRConsentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'consent_levels': ((json['consent_levels'] as Array<any>).map(GDPRConsentLevelFromJSON)),
    };
}

export function GDPRConsentRequestToJSON(json: any): GDPRConsentRequest {
    return GDPRConsentRequestToJSONTyped(json, false);
}

export function GDPRConsentRequestToJSONTyped(value?: GDPRConsentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'consent_levels': ((value['consent_levels'] as Array<any>).map(GDPRConsentLevelToJSON)),
    };
}

